import React from 'react'
import { Route, Switch } from 'react-router-dom'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/transaction'
        render={(routeProps) => (
          <React.Fragment>
            {require('./History').default(routeProps)}
            {require('./PrepaidCardHistory').default(routeProps)}
            {require('./Detail').default(routeProps)}
            {require('./InternationalRemittanceStatus').default(routeProps)}
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default AppRouter
